import { render } from "./shared.vue?vue&type=template&id=0a63ba00"
import script from "./shared.vue?vue&type=script&lang=js"
export * from "./shared.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__